import logo from "@/assets/images/logo.png";
import classNames from "classnames";
import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";
import intl from "react-intl-universal";

const Logo = ({ height, size, color, type }) => {
    const navigate = useNavigate();
    const goHome = () => {
        if (type === 'home') {
            navigate('/');
            window.scrollTo(0, 0);
        }
    };
    return (
        <div className={classNames("flex_box", "align_center", styles.logoBox, type === "home" && styles.pointerBox)} onClick={goHome}>
            <img style={{ "height": height + 'px' }} src={logo} />
            <div style={{ color: color }}>
                <span>{intl.get("Footer.Open Geospatial Engine")}</span>
                <div style={{ "fontSize": size + 'px' }}>{intl.get("Footer.Alliance")}</div>
            </div>
        </div>
    )
}
export default Logo
